import { IItemData } from '@/models';

export interface IItemPaginatedListData {
  count: number;
  next?: string;
  previous?: string;
  results: IItemData[];
}

export interface ItemUploadResponseData {
  id: number;
  file_upload: string;
  owner: string;
  content_type: number;
  created_at: Date;
  updated_at: Date;
}

export interface IItemService {
  exportItems(): Promise<any>;
  fetchItems(
    page: number,
    search?: string,
    snapshot?: number
  ): Promise<IItemPaginatedListData>;
  fetchItem(item: string): Promise<IItemData>;
  createItem(data: IItemData): Promise<IItemData>;
  updateItem(data: IItemData): Promise<IItemData>;
  deleteItem(item: string): Promise<any>;
  uploadItemFile(file: File): Promise<ItemUploadResponseData>;
}

export const UPLOAD_ITEM_FILE_TIMEOUT_IN_MS = 300 * (60 * 1000);
